import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartBarBox = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M10 5.75v8.5m-3.25-5.5v5.5m6.5-3.5v3.5m-9.5 4h12.5a2 2 0 0 0 2-2V3.75a2 2 0 0 0-2-2H3.75a2 2 0 0 0-2 2v12.5a2 2 0 0 0 2 2Z"
	})]
});
const ForwardRef = forwardRef(SvgChartBarBox);
export { ForwardRef as ReactComponent };
